/* Keepsake Lines · theme behaviours (no dependencies) */
(function () {
  'use strict';
  var KL = (window.KL = window.KL || {});
  var cfg = window.KL_CONFIG || {};
  var GIFT_ID = cfg.giftVariantId || 58258940756350;
  var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
  var TIER1 = (cfg.tier1 || 100) * rate * 100; // cents, presentment currency
  var TIER2 = (cfg.tier2 || 130) * rate * 100;
  var store = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { sessionStorage.removeItem(k); } catch (e) {} },
    lget: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    lset: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  function money(cents) {
    var fmt = (cfg.moneyFormat || '${{amount}}');
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, v);
  }

  /* ---------- daily countdown (resets at local midnight) ---------- */
  function tick() {
    var now = new Date();
    var end = new Date(now); end.setHours(24, 0, 0, 0);
    var s = Math.max(0, Math.floor((end - now) / 1000));
    var h = String(Math.floor(s / 3600)).padStart(2, '0');
    var m = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
    var ss = String(s % 60).padStart(2, '0');
    document.querySelectorAll('[data-kl-countdown]').forEach(function (el) {
      var a = el.querySelectorAll('[data-u]');
      if (a.length === 3) { a[0].firstChild.nodeValue = h; a[1].firstChild.nodeValue = m; a[2].firstChild.nodeValue = ss; }
      else el.textContent = h + ':' + m + ':' + ss;
    });
  }
  setInterval(tick, 1000); tick();

  /* ---------- PDP price + tier bar on variant change ---------- */
  function renderTiers(root, total) {
    if (!root) return;
    var fill = root.querySelector('.kl-tiers__fill');
    var nodes = root.querySelectorAll('.kl-tiers__node');
    var msg = root.querySelector('.kl-tiers__msg');
    var pct = total <= TIER1 ? (total / TIER1) * 50 : 50 + ((total - TIER1) / (TIER2 - TIER1)) * 50;
    pct = Math.max(0, Math.min(100, pct));
    if (fill) fill.style.width = pct + '%';
    if (nodes[0]) nodes[0].classList.add('is-done');
    if (nodes[1]) nodes[1].classList.toggle('is-done', total >= TIER1);
    if (nodes[2]) nodes[2].classList.toggle('is-done', total >= TIER2);
    var l1 = root.querySelector('[data-t1]'), l2 = root.querySelector('[data-t2]');
    if (l1) l1.textContent = money(TIER1); if (l2) l2.textContent = money(TIER2);
    if (msg) {
      if (total < TIER1) msg.innerHTML = 'You’re <b>' + money(TIER1 - total) + '</b> away from <b>free shipping</b>';
      else if (total < TIER2) msg.innerHTML = 'Free shipping unlocked · <b>' + money(TIER2 - total) + '</b> more for a <b>free mini print</b>';
      else msg.innerHTML = '<b>All gifts unlocked:</b> free shipping + free mini print';
    }
  }
  KL.renderTiers = renderTiers;

  function updatePrice(variant) {
    if (!variant) return;
    var price = variant.price, was = variant.compare_at_price;
    document.querySelectorAll('[data-kl-pprice]').forEach(function (el) {
      var now = el.querySelector('[data-now]'), w = el.querySelector('[data-was]'), sv = el.querySelector('[data-save]'), pc = el.querySelector('[data-pct]');
      if (now) now.textContent = money(price);
      var on = was && was > price;
      if (w) { w.textContent = on ? money(was) : ''; w.hidden = !on; }
      if (sv) { sv.textContent = on ? 'You save ' + money(was - price) : ''; sv.hidden = !on; }
      if (pc) { pc.textContent = on ? '−' + Math.round((1 - price / was) * 100) + '%' : ''; pc.hidden = !on; }
    });
    document.querySelectorAll('[data-kl-tiers=pdp]').forEach(function (r) { renderTiers(r, price); });
  }
  KL.updatePrice = updatePrice;
  document.addEventListener('variant:update', function (e) {
    var v = e && e.detail && (e.detail.resource || e.detail.variant);
    updatePrice(v);
  });
  // Horizon 3.x no longer emits variant:update — resolve the variant ourselves from the picker
  var productCache = {};
  function productJson(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); });
    }
    return productCache[handle];
  }
  function selectedValues(vp) {
    var vals = [];
    vp.querySelectorAll('select, fieldset').forEach(function (el) {
      if (el.tagName === 'SELECT') vals.push(el.value);
      else { var c = el.querySelector('input:checked'); if (c) vals.push(c.value); }
    });
    return vals;
  }
  function syncFromPicker(vp, changed) {
    if (!vp || vp.closest('product-card')) return;
    var handle = vp.dataset.productHandle || (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    if (!handle) return;
    var vals = selectedValues(vp);
    productJson(handle).then(function (p) {
      var variants = p.variants || [];
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return vals[i] === undefined || o === vals[i]; });
      });
      if (v) { updatePrice(v); return; }
      if (!changed) return;
      // invalid combination (e.g. Canvas + Black frame): jump to the closest real variant
      var groups = Array.prototype.slice.call(vp.querySelectorAll('select, fieldset'));
      var ci = groups.indexOf(changed.closest('select, fieldset'));
      var best = null, bestScore = -1;
      variants.forEach(function (x) {
        if (ci > -1 && x.options[ci] !== vals[ci]) return;
        var score = (x.available ? 0.5 : 0);
        x.options.forEach(function (o, i) { if (o === vals[i]) score += 1; });
        if (score > bestScore) { best = x; bestScore = score; }
      });
      if (!best) return;
      updatePrice(best);
      best.options.forEach(function (o, i) {
        if (o === vals[i] || !groups[i]) return;
        var g = groups[i];
        if (g.tagName === 'SELECT') { g.value = o; g.dispatchEvent(new Event('change', { bubbles: true })); return; }
        var inp = Array.prototype.find.call(g.querySelectorAll('input'), function (n) { return n.value === o; });
        if (inp && !inp.checked) inp.click();
      });
    }).catch(function () {});
  }
  document.addEventListener('change', function (e) {
    var vp = e.target && e.target.closest && e.target.closest('variant-picker');
    if (vp) syncFromPicker(vp, e.target);
  });
  // Horizon 3.x standard event: resolves with the selected variant JSON
  document.addEventListener('shopify:product:select', function (e) {
    if (!e.promise || !e.promise.then || (e.target && e.target.closest && e.target.closest('product-card'))) return;
    e.promise.then(function (r) { var v = r && r.detail && r.detail.resource; if (v && v.price != null) updatePrice(v); }).catch(function () {});
  }, true);
  // morphs can replace inputs: re-sync after any picker DOM change settles
  document.querySelectorAll('variant-picker').forEach(function (vp) {
    if (vp.closest('product-card')) return;
    var t;
    try { new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { syncFromPicker(vp); }, 120); }).observe(vp, { subtree: true, attributes: true, attributeFilter: ['checked', 'data-current-checked'] }); } catch (e) {}
    if (/[?&]variant=/.test(location.search)) syncFromPicker(vp);
  });

  document.querySelectorAll('[data-kl-tiers=pdp]').forEach(function (r) { renderTiers(r, parseInt(r.dataset.price || '0', 10)); });

  // re-render any tier bar Horizon injects (cart drawer re-renders) with the shopper's currency
  function scanTiers(scope) {
    (scope || document).querySelectorAll('[data-kl-tiers]').forEach(function (r) { renderTiers(r, parseInt(r.dataset.price || '0', 10)); });
  }
  if (rate !== 1) scanTiers();
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1 && (n.matches('[data-kl-tiers]') || n.querySelector('[data-kl-tiers]'))) { scanTiers(n.parentNode || document); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}

  /* ---------- cart helpers ---------- */
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  // Horizon 3.x refreshes the cart drawer on Shopify standard events (shopify:cart:lines-update)
  var SE = null;
  var seReady = import('@shopify/events').then(function (m) { SE = m; }).catch(function () {});
  // wait for the module so early announcements (e.g. gift sync on page load) still reach Horizon,
  // which re-renders the drawer section and the count bubble from CartLinesUpdateEvent
  function announce(cart, source, action, lines) {
    seReady.then(function () { announceNow(cart, source, action, lines); });
  }
  function announceNow(cart, source, action, lines) {
    if (SE && SE.CartLinesUpdateEvent) {
      try {
        var d = SE.CartLinesUpdateEvent.createPromise();
        document.dispatchEvent(new SE.CartLinesUpdateEvent({ action: action || 'add', context: 'cart', lines: lines || [], promise: d.promise }));
        d.resolve({
          cart: SE.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, itemCount: cart.item_count, source: source, sourceId: source, didError: false }
        });
        return;
      } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart, sourceId: source, data: { source: source, itemCount: cart.item_count } }
    }));
  }
  function addItems(items, source) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return getCart(); })
      .then(function (cart) {
        // background gift sync must refresh the drawer silently: Horizon only auto-opens on action 'add'
        announce(cart, source, source === 'kl-gift' ? 'update' : 'add', items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }));
        return cart;
      });
  }
  function changeLine(key, qty, source) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      announce(cart, source, qty > 0 ? 'update' : 'remove', [{ id: key, quantity: qty }]);
      return cart;
    });
  }
  KL.addItems = addItems;

  /* ---------- upsell buttons ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-kl-add]');
    if (!b) return;
    e.preventDefault();
    var form = b.closest('[data-kl-up]');
    var props = {};
    if (b.hasAttribute('data-kl-needs-msg')) {
      var box = form && form.querySelector('[data-kl-msg]');
      if (box && box.hidden) { box.hidden = false; var ta = box.querySelector('textarea'); if (ta) ta.focus(); b.textContent = 'Add note'; return; }
      var t = box && box.querySelector('textarea');
      if (t && !t.value.trim()) { t.focus(); return; }
      if (t) props['Gift message'] = t.value.trim().slice(0, 250);
    }
    b.disabled = true; var label = b.textContent; b.textContent = 'Adding…';
    addItems([{ id: parseInt(b.dataset.klAdd, 10), quantity: 1, properties: props }], 'kl-upsell')
      .then(function () { b.textContent = '✓ Added'; b.setAttribute('aria-pressed', 'true'); })
      .catch(function () { b.disabled = false; b.textContent = label; });
  });

  /* ---------- free mini print over tier 2 (auto add / remove) ---------- */
  var busy = false;
  function syncGift(cart) {
    if (busy || !cart) return;
    var gift = null, other = 0, mainItems = 0;
    cart.items.forEach(function (it) {
      if (it.variant_id === GIFT_ID) gift = it;
      else { other += it.final_line_price; mainItems += it.quantity; }
    });
    var eligible = other >= TIER2 && mainItems > 0;
    if (eligible && !gift && store.get('kl_gift_added') && !store.get('kl_gift_dismissed')) {
      // customer removed it themselves: respect that (checked first so it is not re-added on every refresh)
      store.set('kl_gift_dismissed', '1');
    } else if (eligible && !gift && !store.get('kl_gift_dismissed')) {
      busy = true;
      addItems([{ id: GIFT_ID, quantity: 1, properties: { _gift: 'Free mini print over $' + (cfg.tier2 || 130) } }], 'kl-gift')
        .catch(function () {}).then(function () { busy = false; store.set('kl_gift_added', '1'); });
    } else if (!eligible && gift) {
      busy = true;
      changeLine(gift.key, 0, 'kl-gift').catch(function () {}).then(function () { busy = false; store.del('kl_gift_added'); store.del('kl_gift_dismissed'); });
    } else if (eligible && gift && gift.quantity > 1) {
      busy = true;
      changeLine(gift.key, 1, 'kl-gift').catch(function () {}).then(function () { busy = false; });
    }
  }

  /* ---------- cart icon + gift pill ---------- */
  var lastCount = null;
  function cartIcons() { return document.querySelectorAll('cart-icon, .header-actions__cart-icon'); }
  function paintIcon(count, animate) {
    cartIcons().forEach(function (ic) {
      ic.classList.toggle('kl-has-items', count > 0);
      if (animate) { ic.classList.remove('kl-cart-anim'); void ic.offsetWidth; ic.classList.add('kl-cart-anim'); }
    });
  }
  function paintPill(cart) {
    var pill = document.querySelector('[data-kl-gpill]');
    var tpl = (document.getElementById('MainContent') || {}).dataset;
    tpl = tpl && tpl.template || '';
    if (!pill && /^(collection|index|search)/.test(tpl) && document.body) {
      pill = document.createElement('div'); pill.className = 'kl-gpill'; pill.setAttribute('data-kl-gpill', ''); pill.setAttribute('aria-live', 'polite');
      document.body.appendChild(pill);
    }
    if (!pill || !cart) return;
    var other = 0; cart.items.forEach(function (it) { if (it.variant_id !== GIFT_ID) other += it.final_line_price; });
    if (!cart.item_count || other >= TIER2) { pill.classList.remove('is-on'); return; }
    pill.innerHTML = other < TIER1
      ? 'You’re <b>' + money(TIER1 - other) + '</b> from free shipping'
      : 'You’re <b>' + money(TIER2 - other) + '</b> from a free mini print';
    pill.classList.add('is-on');
  }
  function onCart(cart, source) {
    if (!cart) return;
    var c = cart.item_count;
    paintIcon(c, lastCount !== null && c > lastCount);
    lastCount = c;
    paintPill(cart);
    if (source !== 'kl-gift') syncGift(cart);
  }
  document.addEventListener('cart:update', function (e) {
    var d = e.detail || {}; var src = (d.data && d.data.source) || d.sourceId;
    var res = d.resource;
    if (res && res.items) onCart(res, src);
    else getCart().then(function (c) { onCart(c, src); });
  });
  document.addEventListener('shopify:cart:lines-update', function (e) {
    if (!e.promise || !e.promise.then) return;
    e.promise.then(function (r) {
      var d = (r && r.detail) || {};
      if (d.didError) return;
      getCart().then(function (c) { onCart(c, d.source || d.sourceId); });
    }).catch(function () {});
  });
  getCart().then(function (c) { lastCount = c.item_count; paintIcon(c.item_count, false); paintPill(c); syncGift(c); }).catch(function () {});

  /* ---------- collection: see them hung ---------- */
  function setHung(on) { document.documentElement.classList.toggle('kl-hung-on', on); store.lset('kl_hung', on ? '1' : '0'); }
  if (store.lget('kl_hung') === '1') document.documentElement.classList.add('kl-hung-on');
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches('[data-kl-hung]')) setHung(e.target.checked);
  });
  document.querySelectorAll('[data-kl-hung]').forEach(function (i) { i.checked = store.lget('kl_hung') === '1'; });
})();
